<script lang="ts" setup>
const model = defineModel<any>();

withDefaults(
  defineProps<{
    label?: string;
    inlineLabel?: string;
    items?: any[];
    itemTitle?: string;
    itemValue?: string;
    rules?: any[];
    placeholder?: string;
    requiredMark?: boolean;
    type?: string;
    hideDetails?: boolean | 'auto';
    multiple?: boolean;
    chips?: boolean;
    disabled?: boolean;
    closableChips?: boolean;
    width?: string;
    clearable?: boolean;
    readonly?: boolean;
    tooltip?: string;
    tooltipType?: 'info' | 'warning';
    maxWidth?: string | number;
    minWidth?: string | number;
  }>(),
  {
    hideDetails: 'auto',
    tooltipType: 'info',
  },
);
</script>

<template>
  <div
    :style="{ width, minWidth, maxWidth }"
    :data-suge-field="label || inlineLabel || undefined"
    :data-suge-required="requiredMark || undefined"
  >
    <m-input-label
      :text="label"
      :required-mark="requiredMark"
      :tooltip="tooltip"
      :tooltip-type="tooltipType"
    />

    <v-select
      v-model="model"
      :rules="rules"
      variant="outlined"
      dense
      :type="type"
      :placeholder="placeholder"
      :hide-details="hideDetails"
      :label="inlineLabel"
      :items="items"
      :item-title="itemTitle"
      :item-value="itemValue"
      :multiple="multiple"
      :disabled="disabled"
      :chips="chips"
      :closable-chips="closableChips"
      :width="width"
      :clearable="clearable"
      :readonly="readonly"
      :max-width="maxWidth"
      :min-width="minWidth"
    />
  </div>
</template>
